export enum FieldType {
  Text,
  Number,
  DateTime,
  List,
}
